import { render, staticRenderFns } from "./select-video-win.vue?vue&type=template&id=59044ec8&"
import script from "./select-video-win.vue?vue&type=script&lang=js&"
export * from "./select-video-win.vue?vue&type=script&lang=js&"
import style0 from "./select-video-win.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/willin/Documents/shiwangme/shiwangme_new_cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('59044ec8', component.options)
    } else {
      api.reload('59044ec8', component.options)
    }
    module.hot.accept("./select-video-win.vue?vue&type=template&id=59044ec8&", function () {
      api.rerender('59044ec8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "client/components/select-video-win.vue"
export default component.exports